import { Grid, Paper } from "@mui/material";

import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../store";

// @ts-ignore
import "./index.css";
import ThreeComponent from "../../../components/ThreeColumnsComponent";
import TableAbsences from "./TableAnsences";
import { COUPONS_TO_MY_CHARGE_HISTORY_ONE, COUPONS_TO_MY_CHARGE_HISTORY_THREE, COUPONS_TO_MY_CHARGE_HISTORY_TWO } from "../../../constants/signalRequestConsts";
import { searchCouponsToMyChargeEmployeesHistory, setCouponsToMyChargeEmployeesReset } from "../../../store/slices/userRequests";
import MySnackbar from "../../../components/MySnackbar";
import { CouponStatus } from "../../../enumns/Coupons";
import MySelectCompany from "../../../components/MySelectCompany";

// 0: todos los tipos de cupones
// -1: solo vacaciones sunat
// -2: todo menos vacaciones sunat
// const couponId = "-2"

const AbsenceHistory = ({couponId, allowApproveOptions}: {couponId: string, allowApproveOptions?: boolean}) => {

    const dispatch = useDispatch<AppDispatch>();
    const {companyselected, connectionId} = useSelector((state: RootState) => state.auth);
    const [rucSelected, setRucSelected] = useState<string>("")
    const [pageOne, setPageOne] = useState<number>(1)
    const [pageSizeOne, setPageSizeOne] = useState<number>(25)
    const [pageTwo, setPageTwo] = useState<number>(1)
    const [pageSizeTwo, setPageSizeTwo] = useState<number>(25)
    const [pageThree, setPageThree] = useState<number>(1)
    const [pageSizeThree, setPageSizeThree] = useState<number>(25)
    const [statusTwo, setStatusTwo] = useState<string>(`${CouponStatus.Todos}`)
    const [statusThree, setStatusThree] = useState<string>(`${CouponStatus.Utilizados}`)
    const [errorMsg, setErrorMsg] = useState<string>("");

    
    useEffect(() => {
        if (!companyselected || !connectionId || !rucSelected) {
            return;
        }
        dispatch(setCouponsToMyChargeEmployeesReset(COUPONS_TO_MY_CHARGE_HISTORY_TWO));
        dispatch(searchCouponsToMyChargeEmployeesHistory(
            COUPONS_TO_MY_CHARGE_HISTORY_TWO, 
            statusTwo, 
            couponId,
            pageSizeTwo,
            pageTwo,
        ));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [rucSelected, couponId, pageSizeTwo, pageTwo, statusTwo, companyselected, connectionId]);

    useEffect(() => {
        if (!companyselected || !connectionId || !rucSelected) {
            return;
        }
        dispatch(setCouponsToMyChargeEmployeesReset(COUPONS_TO_MY_CHARGE_HISTORY_THREE));
        dispatch(searchCouponsToMyChargeEmployeesHistory(
            COUPONS_TO_MY_CHARGE_HISTORY_THREE, 
            statusThree, 
            couponId,
            pageSizeThree,
            pageThree,
        ));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [rucSelected, couponId, pageSizeThree, pageThree, statusThree, companyselected, connectionId]);

    const getInitialCouponsData = async () => {
        dispatch(searchCouponsToMyChargeEmployeesHistory(
            COUPONS_TO_MY_CHARGE_HISTORY_ONE, 
            `${CouponStatus.Pendientes}`, 
            couponId,
            pageSizeOne,
            pageOne,
        ));
    }

    useEffect(() => {
        if (!companyselected || !connectionId || !rucSelected) {
            return;
        }
        getInitialCouponsData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [rucSelected, couponId]);

    const ComponentOne = useCallback(() => (
        <TableAbsences 
            couponId={couponId}
            rucEmpresa={rucSelected} 
            requestId={COUPONS_TO_MY_CHARGE_HISTORY_ONE}
            allowApproveOptions={allowApproveOptions}
            status={`${CouponStatus.Pendientes}`}
            onUpdate={() => {
                dispatch(searchCouponsToMyChargeEmployeesHistory(
                    COUPONS_TO_MY_CHARGE_HISTORY_ONE, 
                    `${CouponStatus.Pendientes}`, 
                    couponId,
                    pageSizeOne,
                    pageOne,
                ));
                dispatch(searchCouponsToMyChargeEmployeesHistory(
                    COUPONS_TO_MY_CHARGE_HISTORY_TWO, 
                    `${CouponStatus.Todos}`, 
                    couponId,
                    pageSizeTwo,
                    pageTwo,
                ));
            }}
            page={pageOne}
            setPage={setPageOne}
            pageSize={pageSizeOne}
            setPageSize={setPageSizeOne}
        />
    // eslint-disable-next-line react-hooks/exhaustive-deps
    ), [rucSelected]);

    const ComponentTwo = useCallback(() => (
        <TableAbsences 
            couponId={couponId}
            rucEmpresa={rucSelected} 
            requestId={COUPONS_TO_MY_CHARGE_HISTORY_TWO}
            allowApproveOptions={allowApproveOptions}
            status={statusTwo}
            setStatus={setStatusTwo}
            onUpdate={() => {
                dispatch(searchCouponsToMyChargeEmployeesHistory(
                    COUPONS_TO_MY_CHARGE_HISTORY_ONE, 
                    `${CouponStatus.Pendientes}`, 
                    couponId,
                    pageSizeOne,
                    pageOne,
                ));
                dispatch(searchCouponsToMyChargeEmployeesHistory(
                    COUPONS_TO_MY_CHARGE_HISTORY_TWO, 
                    `${CouponStatus.Todos}`, 
                    couponId,
                    pageSizeTwo,
                    pageTwo,
                ));
            }}
            page={pageTwo}
            setPage={setPageTwo}
            pageSize={pageSizeTwo}
            setPageSize={setPageSizeTwo}
        />
    // eslint-disable-next-line react-hooks/exhaustive-deps
    ), [rucSelected]);
    const ComponentThree = useCallback(() => (
        <TableAbsences 
            couponId={couponId}
            rucEmpresa={rucSelected} 
            requestId={COUPONS_TO_MY_CHARGE_HISTORY_THREE}
            status={statusThree}
            setStatus={setStatusThree}
            page={pageThree}
            setPage={setPageThree}
            pageSize={pageSizeThree}
            setPageSize={setPageSizeThree}
        />
    // eslint-disable-next-line react-hooks/exhaustive-deps
    ), [rucSelected]);

    return (
    <Grid item width="100%" marginTop="1.5rem" minHeight="100%">
        <Paper
            elevation={3}
            style={{
                width: "100%", 
                borderRadius: "0.5rem",
                minHeight: "10rem",
                padding: "2rem 1.5rem"
            }}
        >
            <MySelectCompany 
                setRucSelected={setRucSelected} 
                rucSelected={rucSelected}
                includeAllCompaniesOption={true}
                allCompaniesOptionValue={'all'}
            />
            <ThreeComponent
                tabsTitle={["Pendientes", "Aprobados", "Utilizados"]}
                useTabsNameAsTitle={true}
                ComponentOne={ComponentOne}
                ComponentTwo={ComponentTwo}
                ComponentThree={ComponentThree}
            />
        </Paper>
        <MySnackbar 
            open={errorMsg !== ""}
            autoHideDuration={6000}
            msg={errorMsg}
            severity="error"
            onClose={() => setErrorMsg("")} 
        />
    </Grid>)
}

export default AbsenceHistory;